import { render, staticRenderFns } from "./AdminProductHistory.vue?vue&type=template&id=1883ef78&scoped=true"
import script from "./AdminProductHistory.vue?vue&type=script&lang=js"
export * from "./AdminProductHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminProductHistory.vue?vue&type=style&index=0&id=1883ef78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883ef78",
  null
  
)

export default component.exports